import { createRoute, lazyRouteComponent, Outlet } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';
import RequireWarehouse from 'root/RequireWarehouse';

import BinLocationsEnabledRoute from './BinLocationsEnabledRoute';
import { BinLocationsSearchSchema } from './types';

const binLocationsRootRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'bin-locations-root',
});

const BinLocationsRequireWarehouse = () => {
  return (
    <RequireWarehouse
      routeWithWarehouseId="/bin-locations/warehouse/$warehouseId"
      routeWithoutWarehouseId="/bin-locations"
    >
      <Outlet />
    </RequireWarehouse>
  );
};

const requireWarehouseRoute = createRoute({
  getParentRoute: () => binLocationsRootRoute,
  path: '/bin-locations',
  component: BinLocationsRequireWarehouse,
});

const binLocationsWarehouseWrapperRoute = createRoute({
  getParentRoute: () => requireWarehouseRoute,
  path: 'warehouse/$warehouseId',
  parseParams: z.object({ warehouseId: z.string().uuid() }).parse,
});

export const binLocationsEnabledRoute = createRoute({
  getParentRoute: () => binLocationsWarehouseWrapperRoute,
  id: 'binLocationsEnabledRoute',
  component: BinLocationsEnabledRoute,
});

export const binLocationsRoute = createRoute({
  getParentRoute: () => binLocationsEnabledRoute,
  id: 'binLocationsRoute',
  component: lazyRouteComponent(() => import('./BinLocationsView')),
  validateSearch: z.custom<BinLocationsSearchSchema>().parse,
});

const allLocationsRoute = createRoute({
  getParentRoute: () => binLocationsRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./AllLocations/AllLocations')),
});

const pickingRouteRoute = createRoute({
  getParentRoute: () => binLocationsRoute,
  path: 'picking-route',
  component: lazyRouteComponent(() => import('./PickingRoute/PickingRoute')),
});

export const binLocationsRouteTree = binLocationsRootRoute.addChildren({
  requireWarehouseRoute: requireWarehouseRoute.addChildren({
    binLocationsWarehouseWrapperRoute: binLocationsWarehouseWrapperRoute.addChildren({
      binLocationsEnabledRoute: binLocationsEnabledRoute.addChildren({
        binLocationsRoute: binLocationsRoute.addChildren({
          allLocationsRoute,
          pickingRouteRoute,
        }),
      }),
    }),
  }),
});
